module.exports = __webpack_public_path__ + "img/show.61c93bb3.svg";